export default "__VITE_ASSET__VcBesoZu__"